import * as Yup from "yup";
const AddSuppliersSchema = [
  {
    key: "1",
    label: "Supplier Name",
    name: "name",
    validationSchema: Yup.string().required("Name is Required"),
    type: "text",
    initialValue: "",
  },
  {
    key: "2",
    label: "Supplier Location",
    name: "location",
    type: "text",
    validationSchema: Yup.string().required("This field is required"),
    initialValue: "",
  },

  {
    key: "4",
    label: "Minimum Order",
    name: "minOrder",
    type: "number",
    validationSchema: Yup.number()
      .required("Please enter a valid  Amount")
      .min(0, "Price Can Not Be Negative"),
    initialValue: "",
  },
  {
    key: "5",
    label: "Supplier Type",
    name: "supplierType",
    type: "select",
    validationSchema: Yup.string().required("This field is required"),
    initialValue: "",
  },
  {
    key: "3",
    label: "Image",
    name: "image",
    type: "file",
    validationSchema: Yup.string().required("This field is required"),
    initialValue: "",
  },
  {
    key: "6",
    label: "Payment Type",
    name: "payments",
    type: "checkbox",
    options: {
      cash: false,
      card: false,
    },
    validationSchema: Yup.object().required("This field is required"),
    initialValue: {
      cash: false,
      card: false,
    },
  },

  {
    key: "7",
    label: "Information About Supplier",
    name: "info",
    type: "text",
    validationSchema: Yup.string().required("This field is required"),
    initialValue: "",
  },
];

export default AddSuppliersSchema;
